import { createContext } from "react";

export const RolesContext = createContext<any>({})
export const QAContext = createContext<any>({})